module.exports = __webpack_public_path__ + "img/btn_change.d3cc8ed9.png";